var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPepperAvatar = function SvgPepperAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    fill: "#00a1ff",
    r: 40
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50 20.25a4 4 0 0 0 -4-4h-5v-4.69a3 3 0 1 0 -2 0v4.69h-5a4 4 0 0 0 -4 4v.75h20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.82 23.52h-35.64a10.72 10.72 0 0 0 -10.73 10.73v14a10.73 10.73 0 0 0 10.73 10.75h18.45a3.51 3.51 0 0 1 2.24.8l15.77 13.03v-12.83a1.26 1.26 0 0 1 1-1.24 10.71 10.71 0 0 0 8.87-10.56v-14a10.72 10.72 0 0 0 -10.69-10.68zm-29.74 25.32a7.6 7.6 0 1 1 7.6-7.6 7.6 7.6 0 0 1 -7.6 7.6zm22.84 0a7.6 7.6 0 1 1 7.6-7.6 7.6 7.6 0 0 1 -7.6 7.6z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPepperAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pepper-avatar.f586fae63120918b347661ce85accc87.svg";